import * as types from './types';

const initialState = {
	init: {}
};

const gaReducer = (state = initialState, action) => {
	const payload = action.payload;
	switch (action.type) {
		case types.GET_DATA: {
			return {
				...state,
				init: payload.data
			};
		}

		case types.CLEAR_DATA:
			return state;
		default:
			return state;
	}
};
export default gaReducer;
